import React, { useState } from 'react';
import './collectionSimpleCard.css';
import { useResetRecoilState } from 'recoil';
import { Label } from '@nooz-optics/nooz-components-lib';
import { Image } from '../../../Media/Image';
import {
  ILabel,
  ICollection,
  IImage,
} from '../../../../../utils/types/contentful';
import { formatContentfulComponentProps } from '../../../../../utils/globals';
import { withLocale } from '../../../../../utils/hocs';
import { useMediaQuery } from '../../../../../utils/hooks/useMediaQuery';
import { Link } from '../../../Elements/Link';
import { Button } from '../../../Elements';
import { drawerState } from 'utils/recoil/drawer';

export interface CollectionSimpleProps {
  label: ILabel;
  category: ICollection;
  image: IImage;
  hoverImage: IImage;
}

export const PureCollectionSimpleCard = withLocale(
  ({ label, category, image, hoverImage }: CollectionSimpleProps) => {
    const [isImageHovered, setIsImageHovered] = useState(false);
    const resetDrawer = useResetRecoilState(drawerState);
    const isWindowSmallSize = useMediaQuery('sm');
    const opacityChangeDefault = isImageHovered ? 'opacity-0' : 'opacity-100';
    const opacityChangeHover = isImageHovered ? 'opacity-100' : 'opacity-0';

    return (
      <div
        onMouseEnter={() => setIsImageHovered(true)}
        onMouseLeave={() => setIsImageHovered(false)}
        onClick={() => resetDrawer()}
        className='card w-full h-48 md:h-60 lg:h-52 relative cursor-pointer'>
        <Link
          title='Go to collection page'
          type='Page'
          slug={category?.slug}>
          <div className='relative w-full h-full overflow-hidden'>
            <div className='scale-100 hover:scale-105 transform transition-opacity overflow-hidden ease-in-out duration-500 absolute w-full h-full'>
              <Image
                {...image}
                isNative
                objectFit='cover'
                width='100%'
                height='100%'
              />
            </div>
          </div>
          <div className='absolute z-10 top-5 inset-x-5 flex items-center justify-between border-b border-white pb-1'>
            <Label
              size='base'
              weight='bold'
              color={{ classname: 'white' }}
              text={label?.text}
            />
          </div>
          <div className='absolute bottom-4 right-4'>
            <Button
              icon={{
                iconKey: 'HiOutlineChevronRight',
                size: 'sm',
                color: isImageHovered ? category?.color.classname : 'white',
              }}
              type={
                isImageHovered || isWindowSmallSize ? 'contained' : 'outlined'
              }
              size='sm'
              color={{
                classname: isImageHovered ? category?.color.classname : 'white',
              }}
            />
          </div>
        </Link>
      </div>
    );
  }
);

export const CollectionSimpleCard = (props) => (
  <PureCollectionSimpleCard {...formatContentfulComponentProps(props)} />
);
